import axios from "axios";
import { API_BASE_URL } from "../constants/apiEndpoints";

console.log("API Base URL hiện tại là:", API_BASE_URL);
const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    // Gắn token cho các request có chứa '/admin' hoặc api đổi mật khẩu
    if (token && (config.url.includes('/admin') || config.url.includes('/auth/update-password'))) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('accessToken');
            window.location.href = '/admin/auth/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
